import type { FrontendWidget } from '../types';
import { MagazineTableOfContentsComponent } from './MagazineTableOfContentsComponent';
import type {
  MagazineTableOfContentsConfig,
  MagazineTableOfContentsResolved,
} from './types';

/**
 * Inline, **context-backed** (30.03.05 § Classification): `resolveSync` and no
 * backend resolver. A resolver could not serve this block anyway — the entries
 * are derived from the article's block tree, which `BackendResolverContext`
 * deliberately does not carry.
 */
export const magazineTableOfContentsWidget: FrontendWidget<
  MagazineTableOfContentsConfig,
  MagazineTableOfContentsResolved
> = {
  componentType: 'magazine.table-of-contents',
  displayName: 'Article Table of Contents',
  ComponentA: MagazineTableOfContentsComponent,
  resolveSync: () => ({}),
};
